import React, { useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Helmet } from 'react-helmet-async';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import { axiosKK } from '../services/networkRequest';
import errorMessage from '../services/errorMessage';
import SubmitButton from '../components/SubmitButton';
import Button from '../components/Button';
import { Link } from 'react-router-dom';

function ForgotPasswordComponent({ history }: RouteComponentProps): JSX.Element {
  const [email, setEmail] = useState('');
  const [successMessage, setSuccessMessage] = useState<string>();
  const [networkError, setNetworkError] = useState<string>();
  const [fieldError, setFieldError] = useState<string>();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validate = (): boolean => {
    if (!email || email.length < 4) {
      setFieldError('No email');
      return false;
    }
    setFieldError(undefined);
    return true;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;

    setIsSubmitting(true);
    setNetworkError(undefined);
    setSuccessMessage(undefined);

    axiosKK
      .post<{}>('/forgottenPassword', { email })
      .then(() => {
        setSuccessMessage('We have emailed you a reset link');
      })
      .catch((error) => {
        errorMessage(setNetworkError)(error);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="auth-page">
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="auth-card">
        <Button
          variant="tertiary"
          size="sm"
          iconOnly
          aria-label="Back"
          className="auth-card__back"
          onClick={() => history.goBack()}
        >
          <ArrowLeftIcon aria-hidden="true" />
        </Button>

        <div className="auth-card__header">
          <h3>Forgot Password</h3>
          <p>Enter your email and we&apos;ll send you a reset link</p>
        </div>

        {networkError && (
          <div className="auth-card__error">{networkError}</div>
        )}

        {successMessage ? (
          <div className="auth-card__success">
            {successMessage}, <Link to="/login">Back to Login</Link>
          </div>
        ) : (
          <form className="auth-card__form" onSubmit={handleSubmit}>
            <div className="auth-card__field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
              />
              {fieldError && (
                <span className="field-error">{fieldError}</span>
              )}
            </div>

            <SubmitButton disabled={isSubmitting} isSubmitting={isSubmitting}>
              Send Reset Link
            </SubmitButton>
          </form>
        )}

        <p className="auth-card__toggle">
          Remember your password?{' '}
          <button type="button" onClick={() => history.push('/login')}>
            Log in
          </button>
        </p>
      </div>
    </div>
  );
}

export default withRouter(ForgotPasswordComponent);
